import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BRAND } from "../lib/assets";
import { MandalaSVG } from "./Motifs";

const EASE = [0.76, 0, 0.24, 1];

export default function Preloader({ onComplete }) {
  const [count, setCount] = useState(0);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    let current = 0;
    const tick = () => {
      const step = Math.random() * 9 + 2;
      current = Math.min(100, current + step);
      setCount(Math.floor(current));
      if (current < 100) {
        setTimeout(tick, 120);
      } else {
        setTimeout(() => setExiting(true), 500);
      }
    };
    const start = setTimeout(tick, 350);
    return () => clearTimeout(start);
  }, []);

  return (
    <motion.div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink-900"
      initial={{ y: 0 }}
      animate={exiting ? { y: "-100%" } : { y: 0 }}
      transition={{ duration: 1.1, ease: EASE }}
      onAnimationComplete={() => exiting && onComplete()}
    >
      {/* faint mandala behind */}
      <motion.div
        className="absolute h-[120vmin] w-[120vmin] max-w-none animate-spin-slow opacity-[0.06]"
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        transition={{ duration: 3, ease: "easeOut" }}
      >
        <MandalaSVG className="h-full w-full" />
      </motion.div>

      {/* emblem */}
      <motion.img
        src={BRAND.logo}
        alt="Zaya & Zari emblem"
        className="relative w-28 sm:w-36 object-contain"
        initial={{ opacity: 0, scale: 0.8, filter: "blur(8px)" }}
        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        transition={{ duration: 1.4, ease: EASE }}
      />

      {/* wordmark with gold sweep */}
      <div className="relative mt-8 overflow-hidden">
        <motion.h1
          className="font-display text-4xl sm:text-6xl tracking-[0.18em] text-gold"
          initial={{ clipPath: "inset(0 100% 0 0)", opacity: 0.3 }}
          animate={{ clipPath: "inset(0 0% 0 0)", opacity: 1 }}
          transition={{ duration: 2, ease: EASE, delay: 0.4 }}
        >
          ZAYA&nbsp;&amp;&nbsp;ZARI
        </motion.h1>
      </div>

      <motion.p
        className="overline mt-4 text-cream-50/50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
      >
        Luxury Beauty Atelier
      </motion.p>

      {/* progress */}
      <div className="absolute bottom-10 left-0 right-0 flex flex-col items-center gap-3 px-8">
        <div className="h-px w-full max-w-md bg-cream-50/10">
          <motion.div
            className="h-full bg-gold"
            style={{ width: `${count}%` }}
            transition={{ ease: "linear" }}
          />
        </div>
        <span className="font-display text-sm tracking-widest text-cream-50/40">
          {count.toString().padStart(3, "0")}
        </span>
      </div>
    </motion.div>
  );
}
